export default {
      id: "sli-analytics-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.b3fb107f.svg#sli-analytics",
      toString: function () {
        return this.url;
      }
    }